// extracted by mini-css-extract-plugin
export var dividerLine = "_4i-0";
export var errorBackground = "_4i-1";